import axios from "axios";
import router from '../../router/index';

export const state = {
    save_status: false,
    production_cart: {},
    production_batches:{},
    batch_details:{},
    filter_status:false
};

export const getters = {
    ProductionCart: state => state.production_cart.data,
    ProductionBatches: state => state.production_batches.data,
    BatchDetails: state => state.batch_details.data,
    SaveStatus: state => state.save_status,
    filterStatus: state => state.filter_status,

};

export const mutations = {
    set_save_status(state, newValue) {
        state.save_status = newValue;
    },

    set_production_cart(state, newValue) {
        state.production_cart = newValue;
    },

    set_production_batches(state, newValue) {
        state.production_batches = newValue;
    },

    set_filter_status(state, newValue) {
        state.filter_status = newValue;
    },

    set_batch_details(state, newValue) {
        state.batch_details = newValue;
    },
};

export const actions = {
    // Fetch production cart items
    async fetchProductionCart({ commit, dispatch }) {
        commit('set_save_status', true)

        try {
            const response = await axios.get('production_cart');
            commit('set_production_cart', response.data);
            commit('set_save_status', false)

        } catch (error) {
            commit('set_save_status', false)
            let message = { 'msg': "Error Rcording Consumable Item usage " + error }
            dispatch('notification/error', message, { root: true })
        }
    },

    // Add item to production cart
    addToProductionCart({ commit, dispatch }, payload) {
        commit('set_save_status', true);
        axios.post('production_cart', payload)
            .then(() => {
                dispatch('fetchProductionCart');
                const message = { 'msg': 'Production item added to cart successfully' };
                dispatch('notification/success', message, { root: true });
                commit('set_save_status', false);
            })
            .catch(error => {
                commit('set_save_status', false);
                const message = { 'msg': `Error adding production item to cart: ${error}` };
                dispatch('notification/error', message, { root: true });
            });
    },

    // Edit item in production cart
    editProductionCart({ commit, dispatch }, payload) {
        commit('set_save_status', true);
        axios.put(`production_cart/${payload.id}`, payload)
            .then(() => {
                dispatch('fetchProductionCart');
                const message = { 'msg': `Production item ${payload.name} updated successfully in cart` };
                dispatch('notification/success', message, { root: true });
                commit('set_save_status', false);
            })
            .catch(error => {
                commit('set_save_status', false);
                const message = { 'msg': `Error updating production item in cart: ${error}` };
                dispatch('notification/error', message, { root: true });
            });
    },

    // Delete item from production cart
    deleteProductionCart({ commit, dispatch }, payload) {
        commit('set_save_status', true);
        axios.delete(`production_cart/${payload.id}`)
            .then(() => {
                dispatch('fetchProductionCart');
                const message = { 'msg': `Production item ${payload.name} deleted from cart successfully` };
                dispatch('notification/success', message, { root: true });
                commit('set_save_status', false);
            })
            .catch(error => {
                commit('set_save_status', false);
                const message = { 'msg': `Error deleting production item from cart: ${error}` };
                dispatch('notification/error', message, { root: true });
            });
    },
    
    saveProduction({ commit, dispatch }, payload) {
        commit('set_save_status', true);
        axios.post('consumables_usage', payload)
            .then((response) => {
                if(response.status == 200){
                    const message = { 'msg': 'Production Batch Saved successfully' };
                    dispatch('notification/success', message, { root: true });
                }else{
                    const message = { 'msg': response.data.message };
                    dispatch('notification/error', message, { root: true });
                }
                dispatch('fetchProductionCart');                
                commit('set_save_status', false);
            })
            .catch(error => {
                commit('set_save_status', false);
                const message = { 'msg': `Error Saving production Batch : ${error}` };
                dispatch('notification/error', message, { root: true });
            });
    },

    // Fetch Production Batches
    fetchProductionBatches({ commit }) {
        commit('set_filter_status', true);
        axios.get(`production_batches`).then(ec_res => {
        commit('set_filter_status', false);
        commit('set_production_batches', ec_res.data)
        })
    },

    fetchBatchDetails({ commit }, id) {
        commit('set_filter_status', true);
        axios.get(`production_batchdetails/${id}`).then(ec_res => {
        commit('set_filter_status', false);
        commit('set_batch_details', ec_res.data)
        })
    },

    // Edit batch
    editBatch({ commit, dispatch }, payload) {
        commit('set_save_status', true);
        axios.put(`edit_production_batches/${payload.id}`).then((response) => {
            if(response.status == 200) {
                commit('set_save_status', false);
                router.push('/production/cart').catch(() => {});
            }else{
                commit('set_save_status', false);
                let message = { 'msg': response.data.message }
                dispatch('notification/error', message, { root: true })
            }            
        }).catch(() => {
            commit('set_save_status', false)
            let message = { 'msg': "Error Editing Product Batch" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Delete batch
    deleteBatch({ commit, dispatch }, payload) {
        commit('set_save_status', true);
        axios.delete(`delete_production_batches/${payload.id}`).then((response) => {
            if(response.status == 200) {
                dispatch('fetchProductionBatches');
                const message = { 'msg': `Production batch deleted successfully` };
                dispatch('notification/success', message, { root: true });
                commit('set_save_status', false);                
            }else{
                commit('set_save_status', false);
                let message = { 'msg': response.data.message }
                dispatch('notification/error', message, { root: true })
            }   
        }).catch(() => {
            commit('set_save_status', false)
            let message = { 'msg': "Error Deleting Production Batch" }
            dispatch('notification/error', message, { root: true })
        })
    },
};